/* eslint-disable */

import { useEffect, useRef, useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import client from './api/client';
import { useLoadConfig } from './hooks/useLoadConfig';
import { useProductCatalog } from './hooks/useProductCatalog';

import './App.css';
import './components/notification/Notify.css';

import GuestLandingPage from './pages/guest/GuestLandingPage';
import MemberLandingPage from './pages/member/MemberLandingPage';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  const app_hostname = process.env.REACT_APP_BASE_API_URL ?? 'https://meya.co.th';
  const [systemdata_shoporderlist, setystemdata_shoporderlist] = useState([]);

  const [islogin, setIslogin] = useState(false);
  const [isConnectionOpen_notify, setIsConnectionOpen_notify] = useState(false);
  const [messages_raw, setMessages_raw] = useState({});
  const [messages_chat_buffer, setMessages_chat_buffer] = useState({});
  const [messages_chat_unread, setMessages_chat_unread] = useState(0);
  const notify_ws = useRef();
  const [notify_data, setNotify_data] = useState([]);
  const [notify_count, setNotify_count] = useState(0);

  const [popup_register, setpopup_register] = useState(0);
  const [popup_signin, setpopup_signin] = useState(0);

  function generate_token(length) {
    var a = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'.split('');
    var b = [];
    for (var i = 0; i < length; i++) {
      var j = (Math.random() * (a.length - 1)).toFixed(0);
      b[i] = a[j];
    }
    return b.join('');
  }

  const getTokenObject = () => {
    const tokenString = sessionStorage.getItem('meya-token4');
    if (tokenString !== 'undefined' && tokenString !== undefined && tokenString !== null) {
      try {
        const userToken = JSON.parse(tokenString);
        return userToken;
      } catch (e) {}
    }

    return {
      shop_id: '-',
      shop_email: '-',
      shop_username: '-',
      shop_firstname: '-',
      shop_lastname: '-',
      shop_name: '-',
      shop_address: '-',
      shop_country: '-',
      shop_province: '-',
      shop_district: '-',
      shop_subdistrict: '-',
      shop_postcode: '-',
      shop_telno: '-',
      status: '-',
      token: '',
      logintime: '',
      role: 'guest',
      messages_chat_unread: 0,
    };
  };

  const getToken = () => {
    const tokenString = sessionStorage.getItem('meya-token4');
    if (tokenString !== 'undefined' && tokenString !== undefined && tokenString !== null) {
      try {
        const userToken = JSON.parse(tokenString);
        return userToken?.token;
      } catch (e) {}
    }

    return null;
  };

  const saveToken = (userToken) => {
    setToken(userToken?.token || '');
    sessionStorage.setItem('meya-token4', JSON.stringify(userToken));
    if (userToken && userToken.role !== 'guest' && userToken.token && userToken.token !== '-') {
      sessionStorage.removeItem('meya-job-loggedin');
      sessionStorage.removeItem('meya-job-username');
    }
  };

  const [token, setToken] = useState(getToken());
  const [permitdata, setPermitdata] = useState(getTokenObject());

  const queryClient = useQueryClient();
  const config = useLoadConfig(permitdata, app_hostname);
  const productCatalog = useProductCatalog(permitdata, app_hostname);

  useEffect(() => {
    var tokenx = getToken();
    var permitx = getTokenObject();
    const isJobLoggedIn = sessionStorage.getItem('meya-job-loggedin') === 'true';

    if (permitx && permitx.role !== 'guest' && permitx.token && permitx.token !== '-') {
      sessionStorage.removeItem('meya-job-loggedin');
      sessionStorage.removeItem('meya-job-username');
    }

    if (location.pathname === '/' || location.pathname === '') {
      callback_signout('x');
      setIslogin(true);
    } else {
      setpopup_register(0);
      setpopup_signin(0);

      if (location.pathname === '/home' || location.pathname === '/about') {
        setIslogin(false);
      } else if (location.pathname.includes('/passwordreset') || location.pathname.startsWith('/jobs')) {
        setIslogin(true);
      } else {
        const isJobLoggedIn = sessionStorage.getItem('meya-job-loggedin') === 'true';
        if (!tokenx && !isJobLoggedIn) {
          callback_signout('x');
          navigate('/');
          setIslogin(true);
        } else {
          setIslogin(false);
        }
        if (location.pathname === '/myshop/tools/chat') {
          setMessages_chat_unread(0);
        }
      }
    }
  }, [location, token]);

  function callback_mycart(mode, data) {
    if (mode === 'add') {
      config.setCartCount((prev) => prev + 1);
    } else {
      config.setCartCount(data);
    }
  }

  function callback_signin(userdata) {
    saveToken(userdata);

    setPermitdata(userdata);
    setMessages_chat_unread(userdata.messages_chat_unread);
    queryClient.removeQueries({ queryKey: ['market'] });
    navigate('/marketplace?category=สินค้าโปรโมชั่น&&transaction=FNYG18ZWHu');
  }

  function callback_signout(message) {
    var userinitial = {
      shop_id: '-',
      shop_email: '-',
      shop_username: '-',
      shop_firstname: '-',
      shop_lastname: '-',
      shop_name: '-',
      shop_address: '-',
      shop_country: '-',
      shop_province: '-',
      shop_district: '-',
      shop_subdistrict: '-',
      shop_postcode: '-',
      shop_telno: '-',
      status: '-',
      token: '',
      logintime: '',
      role: 'guest',
      messages_chat_unread: 0,
    };
    config.reset();
    queryClient.removeQueries({ queryKey: ['market'] });
    sessionStorage.removeItem('meya-token4');
    sessionStorage.removeItem('meya-job-loggedin');
    sessionStorage.removeItem('meya-job-username');
    sessionStorage.removeItem('job_token');
    sessionStorage.removeItem('job_user_id');
    saveToken(userinitial);
    setPermitdata(userinitial);
  }

  function refresh_shopitems() {
    config.reload();
  }

  function callback_maindatachange(mode, data) {
    const handlers = {
      'shopitem-add': () => {
        refresh_shopitems();
      },

      'shopitem-edit': () => {
        refresh_shopitems();
      },

      'shopitem-delete': () => {
        refresh_shopitems();
      },

      'shopitem-update-stock': () => {
        refresh_shopitems();
      },

      'shopitem-update-blank': () => {
        refresh_shopitems();
      },

      'shoporder-updatebooking-seller': () =>
        updateOrderProperties(data.order_id, {
          order_status: data.order_status,
          shipping_status: data.shipping_status,
          shipping_purchase_id: data.shipping_purchase_id,
          shipping_tracking_code: data.shipping_tracking_code,
          shipping_courier_tracking_code: data.shipping_courier_tracking_code,
        }),

      'shoporder-updatebooking-buyer': () =>
        updateOrderProperties(data.order_id, {
          order_status: data.order_status,
          return_status: data.return_status,
          return_purchase_id: data.return_purchase_id,
          return_tracking_code: data.return_tracking_code,
          return_courier_tracking_code: data.return_courier_tracking_code,
          return_recievename: data.return_recievename,
          return_telno: data.return_telno,
          return_address: data.return_address,
        }),

      'shoporder-updatefullstatus': () => {
        if (data.order_status === 'IV_EXP') {
          setystemdata_shoporderlist(
            systemdata_shoporderlist.filter((order) => order.order_id !== data.order_id),
          );
        } else {
          updateAllOrdersDisplayStatus(data.order_id, {
            order_status: data.order_status,
            shipping_status: data.shipping_status,
            api_paymentstatus: data.api_paymentstatus,
          });
        }
      },

      'shoporder-updatefullstatus-fullrecord': () => {
        setystemdata_shoporderlist(
          systemdata_shoporderlist.map((order) =>
            order.order_id === data.order_id ? data : { ...order, displayitem: false },
          ),
        );
      },

      'shoporder-updatefullstatus-summary': () => {
        setystemdata_shoporderlist(
          systemdata_shoporderlist.map((order) => {
            const fnd = data.find((element) => element.order_id === order.order_id);

            if (fnd !== undefined) {
              return {
                ...order,
                shop_subtotal: fnd.shop_subtotal,
                shop_shipping: fnd.shop_shipping,
                shop_shipping_markup: fnd.shop_shipping_markup,
                shop_servicecharge: fnd.shop_servicecharge,
                shop_total: fnd.shop_total,
                shop_income: fnd.shop_income,
                payment_method: fnd.payment_method,
                displayitem: true,
              };
            } else {
              return { ...order, displayitem: false };
            }
          }),
        );
      },

      'shoporder-updatepayment': () => {
        if (data.order_status === 'IV_Cancel' || data.order_status === 'IV_EXP') {
          setystemdata_shoporderlist(
            systemdata_shoporderlist.filter((order) => order.payment_id !== data.payment_id),
          );
        } else {
          updateOrderPropertiesByPaymentId(data.payment_id, {
            order_status: data.order_status,
            api_paymentstatus: data.api_paymentstatus,
            api_transactionid: data.api_transactionid,
          });
        }
      },

      'shoporder-updatepayment-frombank': () =>
        updateOrderPropertiesByPaymentId(data.payment_id, {
          api_paymentstatus: data.api_paymentstatus,
          api_transactionid: data.api_transactionid,
        }),

      'shoporder-updatepayment-method': () =>
        updateOrderPropertiesByPaymentId(data.payment_id, {
          payment_method: data.payment_method,
          summary_creditcharge: data.summary_creditcharge,
          summary_net: data.summary_net,
        }),

      'myorder-array-add': () => {
        if (data.length > 0) {
          setystemdata_shoporderlist(data.concat(systemdata_shoporderlist));
        }
      },

      'myorder-single-add': () => {
        const fnd_order = data.find((element) => element.seller_shopid === permitdata.shop_id);
        if (fnd_order !== undefined) {
          const fnd = systemdata_shoporderlist.find(
            (element) => element.order_id === fnd_order.order_id,
          );
          if (fnd === undefined) {
            api_getorder_byID(fnd_order.order_id);
          }
        }
      },

      'shoporder-updaterefund': () => removeOrderById(data.order_id),
      'shoporder-updateincome': () => removeOrderById(data.order_id),

      'shoporder-updatetransport-normal': () =>
        updateOrderProperties(data.order_id, {
          shipping_status: data.shipping_status,
        }),

      'shoporder-updatetransport-return': () =>
        updateOrderProperties(data.order_id, {
          return_status: data.return_status,
        }),
    };

    function updateOrderProperties(orderId, properties) {
      setystemdata_shoporderlist(
        systemdata_shoporderlist.map((order) =>
          order.order_id === orderId ? { ...order, ...properties } : order,
        ),
      );
    }

    function updateOrderPropertiesByPaymentId(paymentId, properties) {
      setystemdata_shoporderlist(
        systemdata_shoporderlist.map((order) =>
          order.payment_id === paymentId ? { ...order, ...properties } : order,
        ),
      );
    }

    function updateAllOrdersDisplayStatus(orderId, properties) {
      setystemdata_shoporderlist((prevList) =>
        prevList.map((order) =>
          order.order_id === orderId
            ? { ...order, ...properties, displayitem: true }
            : { ...order, displayitem: false },
        ),
      );
    }

    function removeOrderById(orderId) {
      setystemdata_shoporderlist(
        systemdata_shoporderlist.filter((order) => order.order_id !== orderId),
      );
    }

    if (handlers[mode]) {
      handlers[mode]();
    } else {
      console.warn(`Unhandled mode in callback_maindatachange: ${mode}`);
    }
  }

  useEffect(() => {
    if (permitdata !== null) {
      if (permitdata.shop_id !== undefined) {
        if (permitdata.shop_id !== '-' && permitdata.shop_id !== '') {
          config.load();
        }
      }
    }
  }, [permitdata]);

  async function api_load_config() {
    const formData = new FormData();
    formData.append('shop_id', permitdata.shop_id);
    axios
      .post(app_hostname + '/api/product/common/loadconfig', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
          Authorization: 'Bearer ' + permitdata.token,
        },
      })
      .then((response) => {
        if (response.data.status === 'OK') {
          setSystemdata_productcategorylist(response.data.products_category);
          setBuyer_category(response.data.buyer_category);
          setbuyer_products(response.data.products_shopitem || []);
          setseller_products(response.data.seller_products);
          setSystemdata_shopitemlist(response.data.products_shopitem || []);
          setMycartlen(response.data.cart_count);
          setMyorderlen(response.data.order_count);
        } else {
        }
      })
      .catch((err) => { });
  }

  const { data: myshopOrders } = useQuery({
    queryKey: ['myshop-orders', permitdata?.shop_id],
    queryFn: async () => {
      const formData = new FormData();
      formData.append('shop_id', permitdata.shop_id);
      formData.append('shopitem_count', permitdata.shop_id);
      const response = await client.post('/api/order/myshop/common/getorder', formData, {
        headers: { Accept: 'application/json', 'Content-Type': 'multipart/form-data' },
      });
      if (response.data.status !== 'OK') {
        throw new Error(response.data.message || 'getorder failed');
      }
      return response.data.order;
    },
    enabled: !!permitdata?.shop_id && permitdata.shop_id !== '-',
  });

  useEffect(() => {
    if (myshopOrders) {
      setystemdata_shoporderlist(myshopOrders);
    }
  }, [myshopOrders]);

  async function api_getorder_byID(order_id) {
    try {
      const data = await queryClient.fetchQuery({
        queryKey: ['order-by-id', order_id],
        queryFn: async () => {
          const formData = new FormData();
          formData.append('order_id', order_id);
          const response = await client.post('/api/order/admin/common/getorderbyid', formData, {
            headers: { Accept: 'application/json', 'Content-Type': 'multipart/form-data' },
          });
          if (response.data.status !== 'OK') {
            throw new Error(response.data.message || 'getorderbyid failed');
          }
          return response.data.order;
        },
      });
      setystemdata_shoporderlist((prev) => data.concat(prev));
    } catch (err) {}
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setNotify_count(notify_count + 1);
      if (notify_count > 1 && permitdata !== null) {
        setNotify_count(1);

        if (
          permitdata.token !== '' &&
          permitdata.token !== '-' &&
          isConnectionOpen_notify === false
        ) {
          notify_ws.current = new WebSocket(
            'wss://meya.co.th/api/live/chat/connect?username=' +
              permitdata.shop_id +
              '&&token=' +
              permitdata.token,
          );

          notify_ws.current.onopen = () => {
            console.log('Connection opened');
            setIsConnectionOpen_notify(true);
          };

          notify_ws.current.onmessage = (event) => {
            const data = JSON.parse(event.data);
            setMessages_raw(data);
          };
          notify_ws.current.onclose = (event) => {
            console.log('Connection Lose');
            setIsConnectionOpen_notify(false);
          };

          return () => {
            console.log('Cleaning up...');
            notify_ws.current.close();
          };
        }
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [notify_count]);

  useEffect(() => {
    if (permitdata !== null) {
      if (permitdata.shop_id !== undefined) {
        if (permitdata.shop_id !== '' && permitdata.shop_id !== '-') {
          notify_ws.current = new WebSocket(
            'wss://meya.co.th/api/live/chat/connect?username=' +
              permitdata.shop_id +
              '&&token=' +
              permitdata.token,
          );

          notify_ws.current.onopen = () => {
            console.log('Connection opened');
            setIsConnectionOpen_notify(true);
          };

          notify_ws.current.onmessage = (event) => {
            const data = JSON.parse(event.data);
            setMessages_raw(data);
          };
          notify_ws.current.onclose = (event) => {
            console.log('Connection Lose');
            setIsConnectionOpen_notify(false);
          };

          return () => {
            console.log('Cleaning up...');
            notify_ws.current.close();
          };
        }
      }
    }
  }, [permitdata]);

  useEffect(() => {
    if (permitdata !== null) {
      if (messages_raw.from !== undefined && messages_raw.to !== undefined) {
        if (
          messages_raw.topic === 'chat' &&
          ((messages_raw.from === 'admin' && messages_raw.to === permitdata.shop_id) ||
            (messages_raw.to === 'admin' && messages_raw.from === permitdata.shop_id))
        ) {
          if (location.pathname === '/myshop/tools/chat') {
            setMessages_chat_buffer(messages_raw);
          } else {
            setMessages_chat_buffer({});
            setMessages_chat_unread(messages_chat_unread + 1);
          }
        }
        if (messages_raw.topic === 'order' && messages_raw.to === permitdata.shop_id) {
          const data_in = JSON.parse(messages_raw.data);

          if (messages_raw.popup_enable === true) {
            var id_ref = '';
            if (data_in.order_id !== undefined) {
              id_ref = data_in.order_id;
            }
            if (id_ref === '' && data_in.payment_id !== undefined) {
              id_ref = data_in.order_id;
            }
            if (id_ref === '') {
              id_ref = generate_token(30);
            }

            const fnd_id = notify_data.find((element) => {
              return element.id === id_ref;
            });
            if (fnd_id === undefined) {
              var data = {
                id: generate_token(30),
                icon: messages_raw.popup_class,
                title: messages_raw.popup_title,
                subtitle: messages_raw.popup_subtitle,
                actions: ['รับทราบ'],
              };
              setNotify_data((oldArray) => [...oldArray, data]);
            } else {
              const nextnotify = notify_data.map((notifyx) => {
                if (notifyx.id === id_ref) {
                  return {
                    ...notifyx,
                    icon: messages_raw.popup_class,
                    title: messages_raw.popup_title,
                    subtitle: messages_raw.popup_subtitle,
                  };
                } else {
                  return notifyx;
                }
              });
              setNotify_data(nextnotify);
            }
          }
          callback_maindatachange(messages_raw.mode, data_in);
        }
      }
    }
  }, [messages_raw]);

  function open_signin() {
    setpopup_signin(popup_signin + 1);
  }

  function open_register() {
    setpopup_register(popup_register + 1);
  }

  function callback_notify_ack(notify_id) {
    document.getElementById(notify_id).style.animation = 'flyOutRight 0.3s ease-out forwards';
  }

  function callback_notify_animation(notify_id) {
    var cls = document.getElementById(notify_id);
    if (cls.className === 'my-3 notification__box flyInRight') {
      cls.className = 'my-3 notification__box';
    } else if (cls.className === 'my-3 notification__box') {
      setNotify_data(
        notify_data.filter(function (item) {
          return item.id !== notify_id;
        }),
      );
    }
  }

  return (
    <>
      <ScrollToTop />
      {islogin ? (
        <GuestLandingPage
          permitdata={permitdata}
          popup_register={popup_register}
          popup_signin={popup_signin}
          callback_signin={callback_signin}
          app_hostname={app_hostname}
          open_register={open_register}
          open_signin={open_signin}
          callback_signout={callback_signout}
        />
      ) : (
        <MemberLandingPage
          app_hostname={app_hostname}
          permitdata={permitdata}
          buyer_category={config.buyerCategory}
          systemdata_productcategorylist={config.categories}
          systemdata_shoporderlist={systemdata_shoporderlist}
          systemdata_shopitemlist={config.shopItems}
          shopitem_total={config.shopItemTotal}
          callback_load_shopitems={(page, tab, search, sellerOnly) =>
            config.load(page, tab, search, sellerOnly)
          }
          productCatalog={productCatalog}
          messages_chat_buffer={messages_chat_buffer}
          isConnectionOpen_notify={isConnectionOpen_notify}
          notify_ws={notify_ws}
          mycartlen={config.cartCount}
          myorderlen={config.orderCount}
          messages_chat_unread={messages_chat_unread}
          notify_data={notify_data}
          callback_mycart={callback_mycart}
          callback_maindatachange={callback_maindatachange}
          callback_signout={callback_signout}
          callback_notify_ack={callback_notify_ack}
          callback_notify_animation={callback_notify_animation}
        />
      )}
    </>
  );
}

export default App;
